import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const MySites = lazy(() => import("@/pages/MySites"));

export const Route = createFileRoute("/mina-sidor/")({
  component: () => <MySites />,
});
